import { fmtNum } from "../lib/format";
import { fmtDur } from "../lib/pickerSheet";
import { monthLabel } from "../lib/csvAnalysis";

const th = "text-right py-2 pl-3 font-medium whitespace-nowrap";
const td = "text-right py-1.5 pl-3 whitespace-nowrap";

export const MonthlyBreakdown = ({ rows, hasQty, hasT, notedMonths }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-xs font-mono" data-testid="drilldown-monthly-table">
      <thead><tr className="text-slate-500 border-b border-slate-800">
        <th className="text-left py-2">Month</th><th className={th}>Visits</th>{hasQty && <th className={th}>Qty</th>}
        {hasT && <><th className={th}>Days</th><th className={th}>Absent</th><th className={th}>Hours</th><th className={th}>Visits/hr</th>{hasQty && <th className={th}>Qty/hr</th>}<th className={th}>Lost time</th><th className={th}>Lost/day</th></>}
      </tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r.key} className="border-b border-slate-800/50" data-testid={`drilldown-month-${r.key}`}>
          <td className="py-1.5 text-slate-300 whitespace-nowrap">{monthLabel(r.key)}{notedMonths?.has(r.key) && <span className="ml-1 text-amber-400" title="Has notes" data-testid={`month-has-note-${r.key}`}>✎</span>}</td>
          <td className={`${td} text-slate-200`}>{fmtNum(r.visits)}</td>
          {hasQty && <td className={`${td} text-slate-200`}>{fmtNum(r.qty)}</td>}
          {hasT && <>
            <td className={`${td} text-slate-300`}>{r.days || "—"}</td>
            <td className={`${td} ${r.absent ? "text-amber-300" : "text-slate-600"}`}>{r.absent || "—"}</td>
            <td className={`${td} text-amber-300`}>{r.hrs ? fmtNum(r.hrs) : "—"}</td>
            <td className={`${td} text-ep-soft`}>{r.vph == null ? "—" : fmtNum(r.vph)}</td>
            {hasQty && <td className={`${td} text-emerald-300`}>{r.qph == null ? "—" : fmtNum(r.qph)}</td>}
            <td className={`${td} text-rose-300`}>{r.days ? fmtDur(r.lost) : "—"}</td>
            <td className={`${td} text-rose-300`}>{r.lostDay == null ? "—" : fmtDur(r.lostDay)}</td>
          </>}
        </tr>
      ))}</tbody>
    </table>
  </div>
);
